'use client';
import { ReactNode, createContext, useContext } from 'react';

export interface carouselContexttValue {
  carouselImagePosition?: number | null;
  setCarouselImagePosition?: any;
}

const CarouselContext = createContext({} as carouselContexttValue);

interface ProductProviderProps {
  children: ReactNode;
  value: carouselContexttValue;
}

export const CarouselContextProvider: React.FC<ProductProviderProps> = ({
  children,
  value,
}) => {
  const productContextValue: carouselContexttValue = {
    ...value,
  };
  return (
    <CarouselContext.Provider value={productContextValue}>
      {children}
    </CarouselContext.Provider>
  );
};

const useCarouselContext = () => {
  const context = useContext(CarouselContext);

  if (!context) {
    throw new Error(
      'useCarouselContext must be used within a CarouselContextProvider',
    );
  }

  return context;
};

export default useCarouselContext;
